var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-link.ts
import { A } from "@adornis/base/env-info.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { Subject, filter, fromEvent, merge, takeUntil } from "rxjs";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { acss } from "../../directives/acss.js";
import { injectAttributesOf } from "../../directives/inject-attributes.js";
var linkClicked = new Subject();
var linkReset = {
  textDecoration: "unset",
  color: "inherit",
  cursor: "pointer",
  display: "flex"
};
var XLink = class extends ChemistryLitElement {
  styles() {
    return [
      ...super.styles(),
      { ":host": { display: "inline-flex", flexDirection: "row", cursor: "pointer" } }
    ];
  }
  connectedCallback() {
    super.connectedCallback();
    merge(fromEvent(this, "click"), fromEvent(this, "keydown").pipe(filter((e) => e.code === "Enter"))).pipe(takeUntil(this.disconnected)).subscribe((e) => {
      const composedPath = e.composedPath();
      const linkIndex = composedPath.findIndex((pathEl) => pathEl.nodeName === this.nodeName);
      if (!composedPath.slice(0, linkIndex).find((pathEl) => pathEl.nodeName === "A")) {
        e.stopPropagation();
        this.renderRoot.querySelector("a")?.click();
      } else {
      }
      if (this.getAttribute("href"))
        linkClicked.next(this.getAttribute("href"));
    });
  }
  render() {
    return html`
      <a
        ${acss({ ...linkReset, flex: "1" })}
        href=${ifDefined(this.href)}
        @click=${(e) => {
      const href = this.getAttribute("href");
      if (this.useNativeFunctionality()) {
        if (A.isNative && href && !this.hasSpecialPrefix()) {
          e.preventDefault();
          goTo(href, { target: "_blank" });
        }
        return;
      }
      e.preventDefault();
      if (!href)
        return;
      if (!href.startsWith("http")) {
        goTo(href);
        document.documentElement.scrollTop = 0;
      } else
        goTo(href, { target: "_blank" });
    }}
        ${injectAttributesOf(this, ["href"])}
      >
        <slot></slot>
      </a>
    `;
  }
  useNativeFunctionality() {
    return this.hasSpecialPrefix() || this.shouldBeOpenedExternally() || // edge case: is http link (which implies it should be opened in a new tab, but user specifically asks for it to be opened in this tab)
    this.getAttribute("target") === "_self" && this.getAttribute("href")?.startsWith("http");
  }
  hasSpecialPrefix() {
    return this.getAttribute("href")?.startsWith("mailto") || this.getAttribute("href")?.startsWith("tel");
  }
  shouldBeOpenedExternally() {
    return this.getAttribute("target") === "_blank" || this.getAttribute("target") === "_system";
  }
};
__decorateClass([
  property({ type: String })
], XLink.prototype, "href", 2);
XLink = __decorateClass([
  customElement("x-link")
], XLink);
export {
  XLink,
  linkClicked,
  linkReset
};
